import Spinner from 'spin.js/spin.js';

import BaseComponent from 'source/lib/base_component';

import template from './template.html';

const SPINNER_OPTIONS = {
    lines: 11,
    length: 5,
    width: 2,
    radius: 5,
    corners: 1,
    rotate: 0,
    direction: 1,
    color: '#fff',
    speed: 1.1,
    trail: 60,
    shadow: false,
    hwaccel: false,
    className: 'spinner',
    zIndex: 2e9,
    top: '50%',
    left: '50%',
};

const TwoFactorTimer = BaseComponent.extend({
    name: 'twofactor-timer',
    template,
    initialize(options = {}) {
        this.twofactorMethod = options.twofactorMethod;
        this.requestTimeout = parseInt(options.requestTimeout, 10) || 0;

        // Parse the time stamps from the backend with maximum coverage of possible key formats
        /* eslint-disable max-len */
        const rawResend = options.resendAvailableAt || options.resend_available_at || options['resend-available-at'];
        this.resendAvailableAt = parseInt(rawResend, 10) || 0;

        const rawWindow = options.windowAvailableAt || options.window_available_at || options['window-available-at'];
        this.windowAvailableAt = parseInt(rawWindow, 10) || 0;

        this.isMig = this.twofactorMethod === 'mig';

        // Convert to Boolean (in case the string "true" arrives from the HTML date attributes)
        const rawLastAttempt = options.isLastAttempt || options.is_last_attempt || options['is-last-attempt'];
        this.isLastAttempt = rawLastAttempt === true || rawLastAttempt === 'true';

        BaseComponent.prototype.initialize.call(this, options);

        this.bindElements();

        this.processTimer();
    },
    bindElements() {
        this.$resendButton = this.$el.parent().find('.js-sms-resend-button');
        this.spinner = new Spinner(SPINNER_OPTIONS);
    },
    processTimer() {
        if (this.isLastAttempt) {
            this.disableButton();
            this.showLimitMessage();
            return;
        }

        // If is_last_attempt: false, we calculate the countdown of one SMS and start the counter.
        const nowMs = Date.now();
        const targetMs = this.resendAvailableAt * 1000;
        const totalMs = targetMs - nowMs;

        if (totalMs <= 0) {
            // Countdown time is already over up
            this.enableButton();
            this.hide();
            return;
        }

        this.disableButton();
        this.startCountdown(this.resendAvailableAt);
    },
    restart(customResendAvailableAt) {
        if (customResendAvailableAt) {
            this.resendAvailableAt = parseInt(customResendAvailableAt, 10) || 0;
        }

        this.show();
        this.processTimer();
    },
    startCountdown(availableAtSec) {
        this.data.showTimer = true;
        this.data.showLimitMessage = false;

        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
        }

        const updateTimer = () => {
            const nowSec = Math.floor(Date.now() / 1000);
            this.remainingSeconds = availableAtSec - nowSec;

            if (this.remainingSeconds <= 0) {
                clearInterval(this.countdownInterval);
                this.enableButton();
                this.hide();
                return;
            }

            this.updateTimerDisplay();
        };

        updateTimer();

        if (this.remainingSeconds > 0) {
            this.countdownInterval = setInterval(updateTimer, 1000);
        }
    },
    updateTimerDisplay() {
        const mins = Math.floor(this.remainingSeconds / 60);
        const secs = this.remainingSeconds % 60;

        this.data.timerMinutes = String(mins).padStart(2, '0');
        this.data.timerSeconds = String(secs).padStart(2, '0');
        this.render();
    },
    showLimitMessage() {
        let targetSeconds = 0;

        if (this.windowAvailableAt > 0) {
            // Calculating the difference (delta) between the backend stamps in seconds
            const deltaSeconds = this.resendAvailableAt - this.windowAvailableAt;

            // Getting the current time of the client in seconds
            const nowSeconds = Math.floor(Date.now() / 1000);

            // Calculating the target time (the client's current time + the delta from the backend)
            targetSeconds = nowSeconds + deltaSeconds;
        } else {
            // If the windowAvailableAt is empty/null, we use resendAvailableAt as the absolute point.
            targetSeconds = this.resendAvailableAt;
        }

        // Converting to milliseconds exclusively for the Date constructor
        const targetDate = new Date(targetSeconds * 1000);

        // Getting the current date of the client for comparing calendar days
        const nowDate = new Date();

        // Checking if the target date is today
        const isToday = nowDate.getDate() === targetDate.getDate()
            && nowDate.getMonth() === targetDate.getMonth()
            && nowDate.getFullYear() === targetDate.getFullYear();

        if (isToday) {
            this.data.limitDate = window.gettext('сегодня');
        } else {
            this.data.limitDate = this.formatDate(targetDate);
        }

        this.data.limitTime = this.formatTime(targetDate);
        this.data.showTimer = false;
        this.data.showLimitMessage = true;
        this.render();
    },
    formatDate(date) {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}.${month}.${year}`;
    },
    formatTime(date) {
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
    },
    disableButton() {
        if (this.$resendButton && this.$resendButton.length) {
            this.$resendButton.prop('disabled', true);
            this.$resendButton.addClass('disabled');
        }
    },
    enableButton() {
        if (this.$resendButton && this.$resendButton.length) {
            this.$resendButton.prop('disabled', false);
            this.$resendButton.removeClass('disabled');
        }
    },
    showSpinner() {
        if (this.$resendButton && this.$resendButton.length) {
            this.$resendButton.addClass('button-airy__waiting');
            this.spinner.spin(this.$resendButton[0]);
        }
    },
    hideSpinner() {
        if (this.$resendButton && this.$resendButton.length) {
            this.$resendButton.removeClass('button-airy__waiting');
            this.spinner.stop();
        }
    },
    onResendClick() {
        this.showSpinner();
        this.disableButton();
    },
    onResendComplete() {
        this.hideSpinner();
    },
    hide() { this.$el.hide(); },
    show() { this.$el.show(); },
    remove() {
        if (this.countdownInterval) { clearInterval(this.countdownInterval); }
        if (this.spinner) { this.spinner.stop(); }
        BaseComponent.prototype.remove.call(this);
    },
});

export default TwoFactorTimer;
